import { render } from "./brandCallLogReportCard.vue?vue&type=template&id=2a90337e"
import script from "./brandCallLogReportCard.vue?vue&type=script&lang=js"
export * from "./brandCallLogReportCard.vue?vue&type=script&lang=js"

import "./brandCallLogReportCard.vue?vue&type=style&index=0&id=2a90337e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__